import React, { useContext, useMemo } from 'react';
import { useIntl } from 'umi';
import { IsSingleDay } from '@/pages/dashboard/utils/utils';
import CountryRegionRowItem from '@/pages/dashboard/components/CountryRegionRowItem';
import { PERIODTIMEOBJ } from '@/pages/dashboard/_config/constant';
import { FilterContext } from '@/pages/dashboard/components/PageContainer/context';

const PcInGameBreakdown = (props: any) => {
  const contextObj = useContext(FilterContext);
  const { filterVal: formValue } = contextObj || {};
  const { data: defaultData = [], state, config, gameCode, isDl2 } = props;
  const {
    isHaveBar,
    isHaveLine,
    isHavePie,
    isHaveShare,
    showTable = true,
    showChart = true,
    defaultActive = 0,
    shareMetrics,
  } = config;
  const { regionDataType, breakDownType: breakInGameDownType } = state;
  const {
    data: dataSource,
    loading,
    errorMsg: error,
  } = defaultData?.MonetizationBreakdownRankData || {};

  const breakdownData = useMemo(
    () => ({
      chartData: dataSource?.dwm_data_list || [],
      tableData: dataSource?.dwm_list || [],
    }),
    [dataSource?.dwm_data_list, dataSource?.dwm_list],
  );
  // const { timeType } = formValue || {};
  const { formatMessage } = useIntl();

  const segValue = useMemo(() => regionDataType, [regionDataType]);

  const breakDownType = useMemo(
    () => breakInGameDownType,
    [breakInGameDownType],
  );
  const isSingle = IsSingleDay({
    ...formValue,
    period: PERIODTIMEOBJ[formValue?.timeType],
  });
  const titleNameMap: any = {
    mtx_revenue: formatMessage({ id: 'pc_monetization_MTX_Revenue_title' }),
    platform_mtx_revenue: formatMessage({
      id: 'pc_monetization_MTX_Revenue_title_dl2',
    }),
    mtx_arpu: formatMessage({ id: 'pc_monetization_MTX_ARPU_title' }),
    mtx_arppu: formatMessage({ id: 'pc_monetization_MTX_ARPPU_title' }),
    platform_mtx_arpu: formatMessage({ id: 'pc_monetization_MTX_ARPU_title_dl2' }),
    platform_mtx_arppu: formatMessage({
      id: 'pc_monetization_MTX_ARPPU_title_dl2',
    }),
    mtx_payers: formatMessage({
      id: isDl2 ? 'pc_monetization_mtx_payer_dl2' : 'pc_overview_MTX_Payer',
    }),
    mtx_payer_rate: formatMessage({
      id: isDl2
        ? 'pc_monetization_mtx_payer_rate_dl2'
        : 'pc_overview_MTX_Payer_Rate',
    }),
  };

  const titleAndTypeMap: { [key in string]: string } = {
    mtx_revenue: 'In-Game Revenue',

    mtx_arpu: 'In-Game ARPU',
    mtx_arpu_Day: 'In-Game  ARPU_Day',
    mtx_arpu_Week: 'In-Game  ARPU_Week',
    mtx_arpu_Month: 'In-Game  ARPU_Month',

    mtx_arppu: 'In-Game ARPPU',
    mtx_arppu_Day: 'In-Game  ARPPU_Day',
    mtx_arppu_Week: 'In-Game  ARPPU_Week',
    mtx_arppu_Month: 'In-Game  ARPPU_Month',

    mtx_payers: isDl2 ? 'MTX Payer' : 'In-Game Payer',
    mtx_payers_Day: 'In-Game  Payer_Day',
    mtx_payers_Week: 'In-Game  Payer_Week',
    mtx_payers_Month: 'In-Game  Payer_Month',

    mtx_payer_rate: isDl2 ? 'MTX Payer%' : 'In-Game Payer%',
    mtx_payer_rate_Day: 'In-Game Payer%_Day',
    mtx_payer_rate_Week: 'In-Game Payer%_Week',
    mtx_payer_rate_Month: 'In-Game Payer%_Month',

    // dl2特殊配置
    platform_mtx_revenue: 'MTX Revenue',

    platform_mtx_arpu: 'MTX ARPU',
    platform_mtx_arpu_Day: 'MTX  ARPU_Day',
    platform_mtx_arpu_Week: 'MTX  ARPU_Week',
    platform_mtx_arpu_Month: 'MTX  ARPU_Month',

    platform_mtx_arppu: 'MTX ARPPU',
    platform_mtx_arppu_Day: 'MTX  ARPPU_Day',
    platform_mtx_arppu_Week: 'MTX  ARPPU_Week',
    platform_mtx_arppu_Month: 'MTX  ARPPU_Month',
  };

  const isUserQuotaList: any = ['mtx_payers'];
  // shareMetrics 配置：白名单中的指标才展示 share；未配置则沿用 isHaveShare
  const finalIsHaveShare = Array.isArray(shareMetrics)
    ? shareMetrics.includes(segValue)
    : isHaveShare;
  // const titleAndType = isSingle || segValue === 'mtx_revenue' ? titleAndTypeMap?.[segValue] : titleAndTypeMap?.[segValue + '_' + timeType];
  let chartTooltipsConfig;
  if (isDl2) {
    if (segValue === 'mtx_payers') {
      chartTooltipsConfig = {
        tooltipsName: formatMessage({
          id: 'pc_monetization_mtx_payer_dl2',
        }),
        tooltipsType: 'int',
      };
    } else if (segValue === 'mtx_payer_rate') {
      chartTooltipsConfig = {
        tooltipsName: formatMessage({
          id: 'pc_monetization_mtx_payer_rate_dl2',
        }),
        tooltipsType: 'percent',
      };
    }
  }

  return (
    <CountryRegionRowItem
      titleAndType={titleAndTypeMap?.[segValue]}
      titleName={titleNameMap?.[segValue]}
      responeseValueName={'value'}
      initActiveIndex={defaultActive}
      prefix={
        ['mtx_revenue', 'platform_mtx_revenue'].includes(segValue) ? 'Sum' : 'Avg.'
      }
      regionDataType={breakDownType}
      comConfig={{
        isHaveBar,
        isHaveLine,
        isHavePie,
        isHaveShare: finalIsHaveShare,
      }}
      unit={''}
      timeRange={formValue?.rangeTime}
      loading={loading}
      isSingle={isSingle}
      isError={error}
      data={breakdownData}
      isUserQuota={isUserQuotaList?.includes(segValue)}
      timeType={formValue?.timeType}
      gameCode={gameCode}
      showConfig={{
        showTable,
        showChart,
      }}
      morePie
      // dl2的特殊改动
      chartTooltipsConfig={chartTooltipsConfig}
    />
  );
};

export default PcInGameBreakdown;
